import React, { ReactNode } from 'react'
import ReactModal from 'react-modal'

interface Props {
	/**
	 * This will be displayed at the top of the Modal
	 */
	title: string
	/**
	 * This will be displayed below the title
	 */
	subTitle?: string
	/**
	 * Will make the Modal wider to accomodate larger content
	 */
	wide?: boolean
	/**
	 * Varriable from state to pass that will determine if the Modal should be open or closed
	 */
	isOpen: boolean
	/**
	 * Function that gets passed that will fire when the modal is closed from the X, or by clicking outside of the Modal
	 */
	handleClose: () => void
	/**
	 * Function that gets passed that will fire after the modal is opened
	 */
	onAfterOpen?: () => void
	/**
	 * If set to true, will not allow for closing the modal by clicking outside or hitting escape
	 */
	noClose?: boolean
	children: ReactNode
}

const Modal = ({ title, subTitle, wide, isOpen, handleClose, onAfterOpen, noClose = false, children }: Props) => {
	return (
		<ReactModal
			className={`${
				wide ? 'max-w-5xl' : 'max-w-lg'
			} no-scrollbar z-[99] mx-4 my-auto max-h-[calc(100vh_-_3.5rem)] w-full overflow-auto overflow-y-scroll rounded bg-white shadow-md outline-none`}
			overlayClassName="inset-0 fixed flex items-center justify-center bg-black bg-opacity-50 overflow-auto z-[99]"
			isOpen={isOpen}
			closeTimeoutMS={300}
			onRequestClose={handleClose}
			bodyOpenClassName="overflow-hidden"
			ariaHideApp={false}
			onAfterOpen={onAfterOpen}
			shouldCloseOnOverlayClick={!noClose}
			shouldCloseOnEsc={!noClose}
		>
			<div className="flex justify-between p-5">
				<div>
					<span className="block text-xl font-semibold">{title}</span>
					<span className="text-sm text-gray-500">{subTitle}</span>
				</div>
				{!noClose && (
					<button data-cy="modal-close-button" onClick={handleClose} className="ml-6 scale-x-125 transform font-semibold">
						X
					</button>
				)}
			</div>
			<hr />
			<div data-cy="modal-content-container" className="p-3 sm:p-6">
				{children}
			</div>
		</ReactModal>
	)
}

export default Modal
